import { PaginationResponseDto } from '@tiendanube/common';

export const emptyPagination: PaginationResponseDto = {
  currentPage: 0,
  totalPages: 1,
  totalResults: 0,
  perPage: 20,
  nextPage: null,
};
